import React, { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // При першому рендері пробуємо підтягнути користувача з sessionStorage
  useEffect(() => {
    try {
      const storedUser = sessionStorage.getItem("telegramUser");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (err) {
      console.error("Помилка зчитування користувача з sessionStorage:", err);
    } finally {
      setLoading(false); // навіть якщо користувача нема
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, loading, setLoading, error, setError }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
